












import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import PartnershipForm from '@ui/AudienceCreativeWizard/Forms/PartnershipForm'

settings =
  name: 'PartnershipStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      PartnershipForm,
    }

    computed:
      form: ->
        data: @wizard.audienceCreativeData
        errors: @wizard.audienceCreativeErrors

export default VueOptions.vue settings
